module.exports = __webpack_public_path__ + "media/images/burger-e846f037705241e69f24bb5dffd77216.svg";